import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Icon } from '@iconify/react';
import { PATHS, FEEDBACK_URL } from '../../utils/constants';
import Link from '../../components/Link/Link';
import ExternalLink from '../../components/ExternalLink/ExternalLink';
import { usePermissions } from '../../hooks/usePermissions';

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const NavSlidein: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const { hasPermissions } = usePermissions();
  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setIsOpen((prev) => !prev);
  };

  const navItems = [
    {
      path: PATHS.dashboard,
      icon: 'humbleicons:dashboard',
      text: 'Dashboard',
    },
    {
      path: PATHS.vehicles,
      icon: 'fluent:vehicle-car-24-regular',
      text: 'Vehicles',
    },
    // {
    //   path: PATHS.vehicles,
    //   icon: 'ant-design:search-outlined',
    //   text: 'Service Center',
    // },
    // {
    //   path: PATHS.assignment,
    //   icon: 'cil:loop',
    //   text: 'Assignment',
    // },
    // {
    //   path: PATHS.vehicles,
    //   icon: 'fluent:vehicle-car-24-regular',
    //   text: 'Customer Vehicles',
    // },
    // {
    //   path: PATHS.inventory,
    //   icon: 'fluent:vehicle-car-24-regular',
    //   text: 'Inventory',
    //   hide: !hasPermissions(['ACCESS_INVENTORY_PAGE']),
    // },
    // {
    //   path: PATHS.vehicles,
    //   icon: 'ant-design:search-outlined',
    //   text: 'Service Center',
    // },
    {
      path: PATHS.assignment,
      icon: 'cil:loop',
      text: 'Assignment',
      hide: !hasPermissions(['ACCESS_ASSIGNMENT_PAGE']),
    },
    {
      path: FEEDBACK_URL,
      icon: 'bi:chat-square-dots',
      text: 'Report and Feedback',
      external: true,
    },
    // {
    //   path: PATHS.help,
    //   icon: 'ic:baseline-help-outline',
    //   text: 'Help',
    // },
  ];

  return (
    <Drawer anchor="left" open={isOpen} onClose={toggleDrawer}>
      <Box sx={{ width: 200, p: 3 }} role="presentation" onClick={toggleDrawer} onKeyDown={toggleDrawer}>
        <List>
          {navItems
            .filter((item) => !item.hide)
            .map(({ text, icon, path, external }) => {
              const listItem = (
                <ListItem disablePadding>
                  <ListItemButton sx={{ borderRadius: 2 }}>
                    <ListItemIcon sx={{ minWidth: 30 }}>
                      <Icon icon={icon} fontSize={18} />
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                      primaryTypographyProps={{ fontSize: 14 }}
                      sx={{ color: '#000', fontWeight: '400' }}
                    />
                  </ListItemButton>
                </ListItem>
              );

              if (external) {
                return (
                  <ExternalLink href={path} target="_blank" rel="noreferrer" key={text}>
                    {listItem}
                  </ExternalLink>
                );
              }
              return (
                <Link to={path} key={text}>
                  {listItem}
                </Link>
              );
            })}
        </List>
      </Box>
    </Drawer>
  );
};

export default NavSlidein;
